var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { createStyles, withStyles } from '@material-ui/core/styles';
import MuiAlert from '@material-ui/lab/Alert';
const Alert = withStyles((theme) => createStyles({
    root: {
        flexDirection: 'row-reverse',
        justifyContent: 'space-between',
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        borderBottomLeftRadius: theme.spacing(2),
        borderBottomRightRadius: theme.spacing(2),
    },
    icon: {
        flexDirection: 'column',
        alignContent: 'center',
        justifyContent: 'space-around',
        marginRight: '0',
        marginLeft: theme.spacing(2),
    },
    message: Object.assign({}, theme.typography.body2),
}), {
    name: 'TpNotification',
})(MuiAlert);
/**
 * A Notification toast.
 *
 * This differ from the [@material-ui/lab/Alert](https://material-ui.com/api/alert/#alert-api) for
 *
 * * the icon is on the right instead of the standard left
 * * the top left/right corner are not rounded
 *
 * This should be used positioned on the top of the screen.
 *
 * All the props and examples of the [@material-ui/lab/Alert](https://material-ui.com/api/alert/#alert-api) apply.
 * */
const Notification = (_a) => {
    var { variant = 'filled' } = _a, props = __rest(_a, ["variant"]);
    return (React.createElement(Alert, Object.assign({ variant: variant }, props)));
};
export default Notification;
